import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fetchProducts = async (category) => {
    const res = await axios.get(`${API}/products`, {
        params: category ? { category } : {},
    });
    return res.data;
};

export const formatPrice = (cents, currency = "EUR") =>
    new Intl.NumberFormat("it-IT", { style: "currency", currency }).format(cents / 100);

// EU (Italian) numeric equivalent for letter sizes
export const SIZE_EU = { XS: "40", S: "42", M: "44", L: "46", XL: "48" };

export const formatSize = (size) => (SIZE_EU[size] ? `${size} / EU ${SIZE_EU[size]}` : size);
